import { Component, OnInit, Inject } from "@angular/core";
import { FormBuilder, Validators, FormGroup } from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { GlobalMessages } from "app/app.messages";
import { keyUI, Version } from "app/app.env";
import { Subscription } from "rxjs";
import { AppCodeConfirmService } from "./app-code-confirm.service";
import { AppLoaderService } from "../app-loader/app-loader.service";
import { AppConfirmService } from "app/shared/services/app-confirm/app-confirm.service";

@Component({
  selector: "app-app-code-confirm",
  templateUrl: "./app-code-confirm.component.html",
  styleUrls: ["./app-code-confirm.component.scss"],
})
export class AppCodeConfirmComponent implements OnInit {
  public rForm: FormGroup;
  public globalMessage = GlobalMessages.code2Factor;
  public validCode = false;
  public validSelected = false;
  public methodToSendForm: FormGroup;
  public sendCodeSubscription: Subscription;
  public validateCodeSubscription: Subscription;
  public getContactsSubscription: Subscription;

  public methodToSendCode = [];
  public hideSendKeyButton = false;
  public messageErrorInvalid = "";
  public placeholderSendKey = this.globalMessage.placeholder;
  public maxLengthToMethodSend = 6;
  public titleToMethodSend = this.globalMessage.titleToMethodSend;

  constructor(
    public dialogRef: MatDialogRef<AppCodeConfirmComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    private loader: AppLoaderService,
    public appCodeConfirmService: AppCodeConfirmService,
    private confirm: AppConfirmService
  ) {}

  ngOnInit() {
    this.methodToSendForm = this.fb.group({
      methodToSend: [null, null],
    });

    this.rForm = this.fb.group({
      keyUI: [keyUI],
      ModuleUI: ["app-debtor"],
      VersionUI: [Version],
      IpUI: [""],
      codeCobra: this.data.codeCobra,
      keyUserCompany: this.data.keyUserCompany,
      code2Factor: [
        null,
        Validators.compose([
          Validators.required,
          Validators.minLength(6),
          Validators.maxLength(this.maxLengthToMethodSend),
        ]),
      ],
    });

    // console.log(this.data);

    this.getContacts(
      this.data.codeCobra,
      this.data.keyUserCompany,
      this.data.methodToSendCodeTwoFactor
    );
  }

  signin(_rForm) {
    this.validateKey(_rForm);
  }

  hideDestination(value) {
    var simbol = "";
    var qtdToShow = 4;
    var lengthString = value.length;

    qtdToShow = lengthString / 3;

    if (value.search("@") > 0) {
      simbol = this.padLeft(simbol, qtdToShow, "*");
    } else {
      simbol = this.padLeft(simbol, qtdToShow, "*");
    }

    return value.replace(value.substring(4, value.length - qtdToShow), simbol);
  }

  padLeft(value, length, simbol) {
    var str = String(value);

    while (str.length < length) {
      str = simbol + str;
    }

    return str;
  }

  methodSelected() {
    this.validSelected = false;

    if (this.methodToSendForm.value.methodToSend === undefined) {
      return;
    }

    this.messageErrorInvalid = "";
    this.placeholderSendKey = this.globalMessage.placeholder;

    this.maxLengthToMethodSend = 6;

    if (this.methodToSendForm.value.methodToSend.method == "Digitação") {
      this.hideSendKeyButton = true;
      this.maxLengthToMethodSend = 7;
      this.placeholderSendKey = "Placa do veículo";
    } else {
      this.hideSendKeyButton = false;

      this.messageErrorInvalid = this.globalMessage.errorInvalid;
    }
    this.validSelected = true;
  }

  catchEntry(_value: string) {
    const regex = /\W|_/;

    const entry =
      _value !== null ? _value.toString().replace(regex, "").length : 0;

    if (entry !== null && entry == this.maxLengthToMethodSend) {
      this.validCode = true;
    } else {
      this.validCode = false;
    }
  }

  sendKey(_rForm) {
    this.loader.open(
      `Aguarde, enviando o código para o ${this.methodToSendForm.value.methodToSend.method.toLowerCase()} ${
        this.methodToSendForm.value.methodToSend.destinationView
      }`
    );

    try {
      const dados = {
        keyApp: keyUI,
        keyUserCompany: _rForm.keyUserCompany,
        codeCobra: _rForm.codeCobra,
        destination: this.methodToSendForm.value.methodToSend.destination,
        methodToSendCode:
          this.methodToSendForm.value.methodToSend.method === "E-mail"
            ? "email"
            : this.methodToSendForm.value.methodToSend.method.toLowerCase(),
      };

      this.sendCodeSubscription = this.appCodeConfirmService
        .senKey(dados)
        .subscribe(
          (res: any) => {
            console.log(res);
            this.loader.close();
            this.confirm.confirm(res.result);
          },
          (err) => {
            console.log(err);
            this.loader.close();
            this.confirm.confirm({
              message:
                "Não foi possível enviar o código, verificar o endereço de destino, ou tente mais tarde",
            });
          }
        );
    } catch (error) {
      console.log(error);
      this.loader.close();
      this.confirm.confirm(error);
    }
  }

  async validateKey(_rForm) {
    this.loader.open("Aguarde, validando o código digitado.");

    try {
      const dados = {
        // keyApp: "POSTMAN",
        // keyUserCompany: "kvPPAlqQH7",
        keyApp: keyUI,
        keyUserCompany: _rForm.keyUserCompany,
        codeCobra: _rForm.codeCobra,
        key2FactorToOperator: false,
        methodToValidate: this.methodToSendForm.value.methodToSend.destination,
        key: _rForm.code2Factor,
      };

      this.validateCodeSubscription = this.appCodeConfirmService
        .validateKey(dados)
        .subscribe(
          (res: any) => {
            this.loader.close();

            _rForm.codeValid = true;
            this.dialogRef.close(_rForm);
          },
          (err) => {
            console.log(err);
            this.loader.close();
            this.confirm.confirm({ message: "Código inválido" });
          }
        );
    } catch (error) {
      console.log(error);
      this.loader.close();
      this.confirm.confirm(error);
    }
  }

  getContacts(codeCobra, keyUserCompany, methodToSendCodeTwoFactor) {
    try {
      this.getContactsSubscription = this.appCodeConfirmService
        .getContacts(codeCobra, keyUI, keyUserCompany)
        .subscribe(
          (res) => {
            try {
              const { email, phone } = res;

              if (methodToSendCodeTwoFactor == "Digitação") {
                this.methodToSendCode.push({
                  method: "Digitação",
                  destination: "placa",
                  destinationView: "Placa do veículo",
                });

                this.titleToMethodSend = "Tipo de identificação";
                return;
              }

              if (
                methodToSendCodeTwoFactor == "email" ||
                methodToSendCodeTwoFactor == "free"
              ) {
                email.forEach((element) => {
                  this.methodToSendCode.push({
                    method: "E-mail",
                    destination: element.email,
                    destinationView: this.hideDestination(element.email),
                  });
                });
              }

              if (
                methodToSendCodeTwoFactor == "sms" ||
                methodToSendCodeTwoFactor == "free"
              ) {
                phone.forEach((element) => {
                  this.methodToSendCode.push({
                    method: "SMS",
                    destination: `${element.ddd}-${element.number}`,
                    destinationView: this.hideDestination(
                      `${element.ddd}-${element.number}`
                    ),
                  });
                });
              }

              // this.methodToSendForm
              //   .get("methodToSend")
              //   .patchValue(this.methodToSendCode[0]);
            } catch (e) {
              throw res;
            }
          },
          (err) => {}
        );
    } catch (error) {}
  }
}
